<template>
  <div>
    <p>Please provide the url of your author page from one or more of the following sources to retrieve the necessary information for your profile:</p>
    <li>Google Scholar, e.g.:<br/>https://scholar.google.com/citations?&user=WdS-XBcAAAAJ</li>
    <li>Semantic Scholar, e.g.:<br/>https://www.semanticscholar.org/author/A.-Paramythis/2083785</li>
    <br/>
    <p>
      URL:
    </p>
    <b-form-group v-for="i in numInputForms" :key="i">
      <!--There is also this type of validation, should we use that instead? https://bootstrap-vue.org/docs/reference/validation-->
      <b-row>
        <b-col cols="10">
          <b-form-input type="url" autocomplete="off" v-model="urls[i-1]" name="inputForms" :state="urlState(i) && requiredFieldState(i)"></b-form-input>
          <b-form-invalid-feedback :state="urlState(i) && requiredFieldState(i)">
            <span v-if="!urlState(i)">Enter a valid url.<br/></span><span v-if="!requiredFieldState(i)">This field is required.</span>
          </b-form-invalid-feedback>
          <!--<b-form-invalid-feedback :state="requiredFieldState(i)">
            This field is required.
          </b-form-invalid-feedback>-->
        </b-col>
        <b-col>
          <b-button @click="eraseInput(i)" variant="danger"><b>x</b></b-button>
        </b-col>
      </b-row>
    </b-form-group>

    <b-row class="mt-5">
      <!-- :TODO: Before going into the select-publications view, we should show the progress or at least something that shows that we are waiting for the import -->
      <b-button class="ml-3" type="submit" variant="info" :disabled="submitButtonStatus" v-on:click.prevent="addSource">Create Profile</b-button>
      <b-button class="ml-1" variant="danger" v-on:click.prevent="cancelAddSource">Cancel</b-button>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ResearchProfileCreate',
  props: [ 'profile' ], //will be needed later, when we call this function from the ProfileView
  data() {
    return {
      urls: [],
      numInputForms: 1
    }
  },
  computed: {
    submitButtonStatus() {
      if (this.urls.length > 0)
        return !this.urlState(1);
      else
        return true;
    }
  },
  methods: {
    addInputForm(){
      this.numInputForms+=1;
    },
    urlState(i) {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      if (this.urls[i-1]){
        if (this.urls[i-1].length>0)
          return !!pattern.test(this.urls[i-1]);
      }
      return false;
    },
    requiredFieldState(i) {
      if (i==1) {
        if (this.urls[i-1]) {
          if (this.urls[i-1].length==0)
            return false;
        } else
          return false;
      }
      return true;
    },
    eraseInput(i) {
      var ele=document.getElementsByName('inputForms');
      if (this.urls.length>=i) {
        if (this.urls[i-1].length > 0){
          this.urls.splice(i-1, 1);
          ele[i-1].value = "";
        }
      }
    },
    addSource() {
      var params = {
        "researchProfileId": this.profile.rpid,
        "url": this.urls[0] // :TODO: For now I'm getting only the first url. Should work with more urls in the future (for loop inside the current function)
      }
      this.$emit('selectPublications', true);
      this.$store.dispatch('addSource', params)
    },
    cancelAddSource() {
      var params = {
        "researchProfileId": this.profile.rpid
      }
      console.log(params);
      this.$store.dispatch('deleteResearchProfile', params);
    }
  }
}
</script>

<style scoped>

</style>
